import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  favProductList: [],
  favStoreList: [],
  product: {
    page: 1,
    limit: 10,

    pageInfo: {
      totalPage: 2
    },

    isLike: false,
    list: []
  },
  store: {
    page: 1,
    limit: 10,

    pageInfo: {
      totalPage: 2
    },

    isLike: false,
    list: []
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
